<template>
  <div class="cbs-payment-form">
    <div class="row">
      <div class="col">
        <ul class="list-unstyled error">
          <li v-for="item in paymentErrors" :key="item">{{ item }}</li>
        </ul>
        <!--<div class="error" v-show="paymentError">{{paymentError}}</div>-->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="text-center" v-show="isPaymentInProgress">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">{{ $t("forms.actions.loading") }}</span>
          </div>
        </div>

        <div class="text-center" v-show="!isPaymentInProgress">
          <div
            class="text-center"
            style="max-width: 380px; margin: 0 auto;"
            id="paypal-button-container"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*global paypal*/
import ApiService from "./../../services/apiService.js";
import HtmlService from "./../../services/htmlPageService.js";
import { Promise } from "q";

export default {
  name: "PayPalComponent",
  data: function() {
    return {
      isPaymentInProgress: false,
      paymentErrors: [],
    };
  },
  computed: {
    paypalId: function() {
      return this.$store.state.booking.configuration.paypalId;
    },
  },
  mounted: function() {
    if (!this.paypalId) return;
    let currency = this.$store.state.booking.bookingInfo.selectedCar.currency;
    var scriptUrl = "https://www.paypal.com/sdk/js?commit=true&currency=" + currency + "&client-id=" + this.paypalId;
    HtmlService.loadScript(scriptUrl, () => {
      const _that = this;
      paypal
        .Buttons({
          // onClick is called when the button is clicked
          onClick: (data, actions) => {
            // console.log('PayPal onClick', this, actions);
            let isPaymentInProgress = data.fundingSource == "paypal";
            if (this.isPaymentInProgress) {
              return null;
            }
            this.paymentErrors = [];
            if (this.$store.state.booking.bookingInfo.general.guid) {
              this.isPaymentInProgress = isPaymentInProgress;
              actions.resolve();
              return;
            }

            return this.createBooking()
              .then((result) => {
                console.log("PayPal onClick resolved", result);
                this.isPaymentInProgress = isPaymentInProgress;
                return actions.resolve();
              })
              .catch((err) => {
                console.log("PayPal onClick exception", err);
                this.isPaymentInProgress = false;
                return actions.reject();
              });
          },
          onCancel: (data) => {
            this.isPaymentInProgress = false;
            console.log(data);
            this.paymentErrors = [
              "We could not complete your booking. Payment did not succeed. Please try again.",
            ];
          },
          onError: (err) => {
            this.isPaymentInProgress = false;
            console.log(err);
            this.paymentErrors = [
              "We could not complete your booking. Payment did not succeed. Please try again.",
            ];
          },
          createOrder: (data, actions) => {
            console.log("Create Order", data, actions);
            // This function sets up the details of the transaction, including the amount and line item details.
            let booking = this.$store.state.booking.bookingInfo.general;
            let service = this.$store.state.booking.bookingInfo.selectedCar;
            return actions.order.create({
              intent: "CAPTURE",
              application_context: {
                shipping_preference: "NO_SHIPPING",
                user_action: "PAY_NOW",
              },
              purchase_units: [
                {
                  reference_id: booking.reservationId,
                  description:
                    "Confirmation for booking " + booking.reservationId,
                  custom_id: booking.guid,
                  shipping: null,
                  amount: {
                    currency_code: service.currency,
                    value: service.priceToPayByCard,
                  },
                },
              ],
            });
          },
          onApprove: (data /*, actions*/) => {
            let bookingGuid =
              _that.$store.state.booking.bookingInfo.general.guid;
            let reservationGuids =
              _that.$store.state.booking.bookingInfo.general.reservationGuids;
            let model = {
              bookingGuid: bookingGuid,
              bookingGuids: reservationGuids,
              orderId: data.orderID,
              offer: _that.$store.state.booking.bookingInfo.general.offer,
              total:
                _that.$store.state.booking.bookingInfo.selectedCar
                  .priceToPayByCard,
            };
            console.log("payBookingWithPaypal ", model);
            ApiService.payBookingWithPaypal(model)
              .then(
                (response) => {
                  if (!response.data.success) {
                    this.isPaymentInProgress = false;
                    this.paymentErrors = response.data.errors;
                    return;
                  }
                  this.$store.commit("booking/setCurrentStep", 5);
                },
                () => {
                  this.isPaymentInProgress = false;
                  this.paymentErrors = [this.$t("forms.payment.errorGeneral")];
                }
              )
              .catch(() => {
                this.isPaymentInProgress = false;
                this.paymentErrors = [this.$t("forms.payment.errorGeneral")];
              });
          },
        })
        .render("#paypal-button-container");
    });
  },
  methods: {
    sleep: function(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    createBooking: function() {
      //create booking
      var bookingInfo = this.$store.state.booking.bookingInfo;
      var bookingInfoModel = {
        hash: bookingInfo.selectedCar ? bookingInfo.selectedCar.hash : null,
        guid: bookingInfo.general.guid,
        paymentMethod: "PayPal",
        passengerDetails: bookingInfo.passengerDetails,
        numberOfCars: bookingInfo.general.numberOfCars,
      };
      let result = new Promise((res, rej) => {
        ApiService.createBooking(bookingInfoModel)
          .then((response) => {
            if (!response.data.success) {
              console.log("createBooking error", response.data.errors);
              this.isPaymentInProgress = false;
              this.paymentErrors = response.data.errors;
              rej("error creating booking");
              return;
            }
            this.$store.commit(
              "booking/setBookingGuid",
              response.data.result.guid
            );
            this.$store.commit(
              "booking/setBookingHash",
              response.data.result.hash
            );
            this.$store.commit(
              "booking/setReservationId",
              response.data.result.reservationId
            );
            this.$store.commit(
              "booking/setReservationGuids",
              response.data.result.allGuids
            );
            res(response.data.result);
          })
          .catch((err) => {
            this.isPaymentInProgress = false;
            console.log("createBooking error", err);
            this.paymentErrors = [this.$t("forms.payment.errorGeneral")];
            rej("error creating booking");
          });
      });
      return result;
    },
  },
};
</script>

<style>
.cbs-payment-form .error {
  color: #e25950;
  text-align: center;
  margin-bottom: 20px;
}
</style>
